import {useDispatch, useSelector} from "react-redux";
import classNames from "classnames";
import React, {useEffect, useState} from "react";
import moment from "moment-timezone";
import { updateAccountData} from "../../../actions";
import AjaxButton from "../../../../form/ajax_button";
import axios from "axios";

export default function AccountSettings() {
  const dispatch = useDispatch()
  const account = useSelector((state) => state.account)
  const accountGoOnlineSupportChatSessionUrl = useSelector((state) => state.accountGoOnlineSupportChatSessionUrl)
  const accountGoOfflineSupportChatSessionUrl = useSelector((state) => state.accountGoOfflineSupportChatSessionUrl)
  const accountSetSendSupportChatNotificationUrl = useSelector((state) => state.accountSetSendSupportChatNotificationUrl)
  const accountOrganization = useSelector(state => state.accountOrganization)
  const backgroundColor = accountOrganization?.brand_color_1 || "#0ECC46";
  const sendSupportChatNotification = account.send_support_chat_notification


  const getIsAccountOnline = (account) => {
    return !!account.last_online_at
    // let accountLongestAgoTillNotOnline = moment().subtract(14, 'minutes')
    // return account.last_online_at && moment(account.last_online_at).isAfter(accountLongestAgoTillNotOnline)
  }

  const isAccountOnline = getIsAccountOnline(account)

  const sendUpdateAccountOnlineStatus = (account) => {
    const isOnline = getIsAccountOnline(account)
    console.log("account.last_online_at", account.last_online_at)

    if (isOnline) {
      console.log("Updating last online")
      axios({

        method: "put",
        url: accountGoOnlineSupportChatSessionUrl,
        data: {}
      }).then(
        (data) => {
          if (data.data.status === "OK") {
            dispatch(updateAccountData(data.data.account))
          } else {
            alert(data.data.message || "A error occurred while updating online status online.")
          }
        },
        (error) => {
          console.error(error)
          alert(error || "A error occurred while updating online status online.")
        }
      );
    } else {
      console.log("Not updating last online")
    }
  }

  useEffect(() => {
    sendUpdateAccountOnlineStatus(account)

    const interval = setInterval(() => {
      sendUpdateAccountOnlineStatus(account)
    // }, 30 * 1000);
    }, 13 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return <div className={"row p-3"}>
    <div className="col-12">
      <h4>
        Support chat
        <div className="float-right">
          <AjaxButton
            method="put"
            style={{color: backgroundColor, padding: 0}}
            doNotSetFaClass={true}
            className={classNames("mr-3 btn btn-link")}
            icon={sendSupportChatNotification ? "far fa-check-square" : "far fa-square"}
            url={accountSetSendSupportChatNotificationUrl}
            data={{
              enable_support_chat_notifications: !sendSupportChatNotification
            }}
            onSuccess={(data) => {
              if (data.data.status === "OK") {
                dispatch(updateAccountData(data.data.account))
              } else {
                alert(data.data.message || "A error occurred while changing the support chat notification state.")
              }
            }}
            onError={(error) => {
              alert("Error while changing the support chat notification state.", error)
            }}
          >
            <i className="fas fa-envelope"/>
          </AjaxButton>

          {isAccountOnline ? <AjaxButton
            method="put"
            labelSending="Going offline ..."
            style={{color: backgroundColor, padding: 0}}
            className={classNames("btn btn-link float-right")}
            icon="fa-toggle-on"
            url={accountGoOfflineSupportChatSessionUrl}
            data={{}}
            label={"Go Offline"}
            onSuccess={(data) => {
              if (data.data.status === "OK") {
                console.log(data.data.account)
                dispatch(updateAccountData(data.data.account))
              } else {
                alert(data.data.message || "A error occurred while going offline.")
              }
            }}
            onError={(error) => {
              console.log(error)
              alert("Error while going offline.", error)
            }}
          /> : <AjaxButton
            method="put"
            labelSending="Going online ..."
            style={{color: backgroundColor, padding: 0}}
            className={classNames("btn btn-link")}
            icon="fa-toggle-off"
            url={accountGoOnlineSupportChatSessionUrl}
            data={{}}
            label={"Go Online"}
            onSuccess={(data) => {
              if (data.data.status === "OK") {
                dispatch(updateAccountData(data.data.account))
              } else {
                alert(data.data.message || "A error occurred while going online.")
              }
            }}
            onError={(error) => {
              console.log(error)
              alert("Error while going online.", error)
            }}
          />}
          
        </div>
      </h4>
    </div>
  </div>
}